// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__Xuuc7","modal":"style_modal__ry-Ep","container":"style_container__fI4Sa","content":"style_content__DQdF2"};